// time taken
export const TIME_TAKEN_STAFF_DEFAULT = {
    physician_xiaflex: 82.6,
    nurse_xiaflex: 31.9,
    other_xiaflex: 139,
    physician_fasciectomy: 236.1,
    nurse_fasciectomy: 334.3,
    other_fasciectomy: 464.1
}

export const TIME_TAKEN_TASK_DEFAULT = {
    patient_consultation_xiaflex: 44.8,
    procedure_planning_xiaflex: 24.1,
    patient_check_in_xiaflex: 22.0,
    room_and_materials_preparation_xiaflex: 12.6,
    procedure_xiaflex: 32.9,
    recovery_and_discharge_xiaflex: 9.3,
    follow_up_visits_xiaflex: 76.3,
    physical_therapy_xiaflex: 31.5,

    patient_consultation_fasciectomy: 58,
    procedure_planning_fasciectomy: 53.6,
    patient_check_in_fasciectomy: 7.6,
    room_and_materials_preparation_fasciectomy: 72.3,
    procedure_fasciectomy: 427.9,
    recovery_and_discharge_fasciectomy: 68,
    follow_up_visits_fasciectomy: 89.9,
    physical_therapy_fasciectomy: 257.2
}

export const VALUE_OF_TIME_STAFF_DEFAULT = {
    physician: 878.423260137243,
    nurse: 144.74670014556,
    other: 50.5410924148632,
}

export const VALUE_OF_TIME_HOURS_ALT_DEFAULT = {
    physician: 52.8,
    nurse: 31.8,
    other: 204.6
}

export const SCENARIO_DEFAULT = {
    num_dc_patients: 100,
    baseline_xiaflex: 20,
    new_xiaflex: 100
}

export const FORMULAS = {
    round: (a) => { return Math.round(a * 10) / 10; },
    roundWhole: (a) => { return Math.round(a); },
    roundAndKeep1Decimal: (a) => { return parseFloat((Math.round(a * 10) / 10).toFixed(1)); },
    convertToCurrency: (a) => { 
        return "$" + a.toLocaleString('en-US', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        });
    },
    convertToCurrencyWhole: (a) => { 
        return "$" + a.toLocaleString('en-US', {
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
        });
    },
    convertToThousandsWithCommas: (a) => {
        return a.toLocaleString('en-US', {
            minimumFractionDigits: 0,
            maximumFractionDigits: 2
        });
    }
}